import { useRoute } from "preact-iso";
import "./Search.scss";
import { useEffect, useState } from "preact/hooks";
import { fetchSearch } from "../../services/coupon.service";
import CouponComponent, { Coupon } from "../Coupons/Coupon/Coupon";
import LoadingIcon from "../LoadingIcon/LoadingIcon";

const SearchComponent = () => {
  const { params } = useRoute();
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (params?.query) {
      document.title = `${params.query} coupons in Utah County — EZ Coupons`;
    } else {
      document.title = "Search coupons — EZ Coupons";
    }
  }, [params?.query]);

  useEffect(() => {
    if (params?.query) {
      fetchSearch(params.query)
        .then(res => {
          if (res?.data && res.data[0]) {
            setCoupons(res.data);
          }
        })
        .catch(() => {})
        .finally(() => setIsLoaded(true));
    } else {
      setIsLoaded(true);
    }
  }, [params?.query]);

  return (
    <div className={"search-container"}>
      <h1>Search results for "{params?.query}"</h1>
      {isLoaded ? (
        coupons.length === 0 ? (
          <p>No coupons found matching "{params?.query}". Try a different search.</p>
        ) : (
          <div className={"search-results"}>
            {coupons.map((coupon, index) => (
              <CouponComponent coupon={coupon} key={"search-" + index} />
            ))}
          </div>
        )
      ) : (
        <LoadingIcon />
      )}
    </div>
  );
};

export default SearchComponent;
